import agent, { ListData } from "../api/agent";
import { DataTableList } from "../common/interfaces/TableData";
import { MemberDocument } from "../common/interfaces/MemberDocument";

export type DocumentStore = {
  tableData: DataTableList<MemberDocument>;
  loadingInitial: boolean;
  loading: boolean;

  loadDocumentsForMember: (memberId: string) => Promise<ListData<MemberDocument> | void>;
  uploadDocument: (memberId: string, file: File, description: string) => Promise<void>;
  downloadDocument: (item: MemberDocument) => Promise<void>;
  deleteDocument: (id: string) => Promise<void>;
  setLoadingInitial: (state: boolean) => void;
};

export const createDocumentStore = (set: any, get: any): DocumentStore => ({
  tableData: new DataTableList<MemberDocument>(),
  loadingInitial: false,
  loading: false,

  loadDocumentsForMember: async (memberId: string) => {
    set((state: any) => ({ documentStore: { ...state.documentStore, loadingInitial: true } }));
    try {
      const result = await agent.Documents.list(memberId);
      const list = result.data.reduce((acc: Map<string, MemberDocument>, item: MemberDocument) => {
        acc.set(item.id!, item);
        return acc;
      }, new Map<string, MemberDocument>());
      set((state: any) => ({
        documentStore: {
          ...state.documentStore,
          tableData: { ...state.documentStore.tableData, list, totalRecords: result.totalRecords },
          loadingInitial: false,
        },
      }));
      return result;
    } catch (error) {
      console.log(error);
      set((state: any) => ({ documentStore: { ...state.documentStore, loadingInitial: false } }));
    }
  },

  uploadDocument: async (memberId: string, file: File, description: string) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("memberId", memberId);
    formData.append("description", description);
    await agent.Documents.upload(formData);
  },

  downloadDocument: async (item: MemberDocument) => {
    const response = await agent.Documents.downloadDocument(item.id);
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", item.name);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },

  deleteDocument: async (id: string) => {
    set((state: any) => ({ documentStore: { ...state.documentStore, loading: true } }));
    try {
      await agent.Documents.delete(id);
      set((state: any) => {
        const map = new Map(state.documentStore.tableData.list);
        map.delete(id);
        return {
          documentStore: {
            ...state.documentStore,
            tableData: { ...state.documentStore.tableData, list: map },
            loading: false,
          },
        };
      });
    } catch (error) {
      console.error(error);
      set((state: any) => ({ documentStore: { ...state.documentStore, loading: false } }));
      throw error;
    }
  },

  setLoadingInitial: (stateValue: boolean) => {
    set((state: any) => ({ documentStore: { ...state.documentStore, loadingInitial: stateValue } }));
  },
});